import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { ISterilisationPackContent } from '@principle-theorem/principle-core/interfaces';
import { isSameRef } from '@principle-theorem/shared';
import { BehaviorSubject } from 'rxjs';

export interface IPackContentsDialogData {
  content: ISterilisationPackContent[];
}

@Component({
  selector: 'pr-pack-contents-dialog',
  imports: [NgDialogModule, MatIcon],
  templateUrl: './pack-contents-dialog.component.html',
  styleUrl: './pack-contents-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackContentsDialogComponent {
  readonly dialogRef = inject(MatDialogRef<PackContentsDialogComponent>);
  data = inject<IPackContentsDialogData>(MAT_DIALOG_DATA);
  content$ = new BehaviorSubject<ISterilisationPackContent[]>([]);

  constructor() {
    this.content$.next(this.data.content);
  }

  save(): void {
    this.dialogRef.close(this.content$.value);
  }

  changeQuantity(content: ISterilisationPackContent, quantity: number): void {
    const currentContent = this.content$.value;
    const changedContent = currentContent.map((item) =>
      isSameRef(content.item, item.item) ? { ...item, quantity } : item
    );
    this.content$.next(changedContent);
  }
}
